import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import Dropzone from "react-dropzone";
import { useSelector, useDispatch } from "react-redux";
import { TextField, Button, Select, MenuItem, Card, InputLabel, FormControl, Grid, Chip, IconButton, Typography } from "@mui/material";
import BackupIcon from "@mui/icons-material/Backup";
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import { makeStyles } from "@mui/styles";
import Stack from "@mui/material/Stack";
import { ButtonSubmitProgress } from "../../components/form/Buttons";
import { objectToFormData } from '../../Utils/formUtils.js'
import { snackAction } from '../../components/CustomSnakbar.jsx'
import { ROUTES } from '../../constants'
import { getCategory, getCustomFields, getSupplierTickets, newTicket, getCountriesHash, getTickets } from "../../Store/Ducks/duckTickets";
import { getSupplierCuit } from "../../Store/Ducks/duckSupplier";
import "../../Styles/uploadFiles.css";
import CcPopup from "../../components/ui/CcPopup";

const useStyles = makeStyles((theme) => ({
  formControl: {
  },
  card: {
    padding: "30px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)"
  },
  chip: { marginTop: "15px" },
  category: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around"
  }
}));

export const TicketCreation = ({ email }) => {

  const [selectedFiles, setFiles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [selectedCuit, setSelectedCuit] = useState(null);
  const [selectedCc, setSelectedCc] = useState();
  const [onSubmit, setOnSubmit] = useState(false);
  const [openCc, setOpenCc] = useState(false);
  const [cc, setCc] = useState('');
  const [allCc, setAllCc] = useState([])
  const [countryLongName, setCountryLongName] = useState('');
  const [supplierCustomField, setSupplierCustomField] = useState({})
  const [countryCustomField, setCountryCustomField] = useState({})
  const [documentCustomField, setDocumentCustomField] = useState({})
  const [countriesHashValue, setCountriesHashValue] = useState([])
  const [selectedSociety, setSelectedSociety] = useState(0);

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const location = useLocation();
  const { companyFromAccount, nifFromAccount, categoryFromAccount, invoiceFromAccount, origin } = location.state || {};

  const categories = useSelector(store => store.tickets?.data?.categories) || [];
  const supplierTickets = useSelector(store => store.tickets?.data?.supplierTickets) || [];
  const availablesCUIT = useSelector(store => store.supplier?.data?.availablesCUIT) || [];
  const customFields = useSelector(store => store.tickets?.data?.customFields) || [];
  const country = useSelector(store => store.countries?.data.find(item => item.selected)) || [];
  const societies = useSelector((store) => store.societies.data.filter(x => x.selected)).sort((a, b) => a.nif.localeCompare(b.nif));
  const countriesHash = useSelector((store) => store.tickets?.data?.countriesHash) || [];
  const tickets = useSelector((store) => store.tickets.data.tickets);

  //const societyValueFromAccount = societies.filter(soc => soc.description === companyFromAccount).map((soc) => soc.id)
  const societyValueFromAccount = societies.filter(soc => soc.code === companyFromAccount).map((soc) => soc.id)
  
  const nifValueFromAccount = availablesCUIT.filter(cuit => cuit.cuit === nifFromAccount).map(cuit => cuit.cuit)
  const categoryValueFromAccount = categories.filter(cat => cat.id === 7).map(cat => cat.id)
  const subCategoryValueFromAccount = categories.filter(cat => cat.id === 7).map(cat => cat.id)

  useEffect(() => {
    if (societies && societies.length === 0) {
      enqueueSnackbar("Debe seleccionar un país", { variant: "warning", action: snackAction, autoHideDuration: 3000 });
      history.push(ROUTES.SELECT_COUNTRY)
    }
  }, [enqueueSnackbar, history, societies])

  useEffect(() => {
    dispatch(getTickets(email))
    tickets.length > 0 && dispatch(getSupplierTickets(email))
  }, [dispatch, email, tickets.length])

  useEffect(() => {
    dispatch(getCategory(email))
    dispatch(getSupplierCuit(email))
  }, [dispatch, email])

  useEffect(() => {
    dispatch(getCountriesHash())
  }, [dispatch])

  useEffect(() => {
    if (origin === 'fromAccount') {
      setSelectedSociety(societies.find(soc => soc.code === companyFromAccount)?.id || null);
      setSelectedCuit(availablesCUIT.find(cuit => cuit.cuit === nifFromAccount)?.cuit || null);
    }
    else if (availablesCUIT?.length === 1) {
        setSelectedCuit(availablesCUIT[0]?.cuit || null);
    }
    
  }, []);

  useEffect(() => {
    if (origin === 'fromAccount') {
      setSelectedCategory(categories.find(cat => cat.id === categoryFromAccount)?.id || null);
      setSelectedSubCategoryId(categories.find(cat => cat.id === categoryFromAccount)?.id || null);
    }
  }, [origin, categories]);

  useEffect(() => {
    if (societies.length > 0 && countriesHash.length > 0) {
      const chosenSociety = societies?.filter(society => society.id === selectedSociety)
      const allHash = countriesHash?.filter(countryHash => countryHash.name === countryLongName)
      // const chosenHash = allHash[0]?.children?.filter(child => {
      //   const societyNames = chosenSociety.map(society => society.code + '-' + society.description);
      //   return societyNames.includes(child.name);
      // }) ?? []
      const chosenHash = allHash[0]?.children?.filter(child => child.key === chosenSociety[0]?.code) ?? []
      setCountriesHashValue(chosenHash)
    }
  }, [selectedSociety, countryLongName, countriesHash])

  useEffect(() => {
    if (country && country.name && country.longName) {
      setCountryLongName(country.longName);
      //setCountryValue({ [country.name]: country.longName });
    }
  }, [country, countriesHash]);

  useEffect(() => {
    const selectedCategory = categories.find(category =>
      category.category === categories.find(cat => cat.id === selectedSubCategoryId)?.category &&
      category.id === selectedSubCategoryId
    );
    if (selectedCategory) {
      dispatch(getCustomFields(selectedCategory.invgateID));
    }
  }, [dispatch, categories, selectedSubCategoryId]);

  useEffect(() => {
    customFields && selectedSubCategoryId && customFields.map((field) => {
      if (field.uid === '1') {
        setSupplierCustomField({
          ...supplierCustomField,
          [field.uid]: availablesCUIT?.length === 1 ? availablesCUIT[0]?.cuit : selectedCuit
        })
      }
      if (field.uid === '2') {
        setCountryCustomField({
          ...countryCustomField,
          [field.uid]: countriesHashValue[0]?.hash
        })
      }
    }
    )
  }, [customFields, selectedCuit, countriesHashValue])

  useEffect(() => {
    customFields.map((field) => {
      if (origin === 'fromAccount' && field.uid === '6') {
        setDocumentCustomField({
          ...documentCustomField,
          [field.uid]: invoiceFromAccount
        })
      }
    })
  }, [customFields, origin])

  useEffect(() => {
    if (allCc && allCc.length > 0) {
      setSelectedCc(allCc.join(" ; "))
    }
  }, [cc, allCc])

  const handleOpenCc = () => {
    setOpenCc(true);
  };

  const onDrop = (cfiles) => {
    if (cfiles.length > 0) {
      const newFiles = cfiles.filter((file) => {
        for (let i = 0; i < selectedFiles.length; i++) {
          if (selectedFiles[i].name === file.name && selectedFiles[i].size === file.size) {
            return false;
          }
        }
        return true;
      });
      setFiles([...selectedFiles, ...newFiles]);
    }
  };

  const handleDelete = (fileToDelete) => {
    const newFiles = selectedFiles.filter((file) => file !== fileToDelete);
    setFiles(newFiles);
  }

  const handleClickCancel = () => {
    if (origin === 'fromAccount'){
      history.push(`${ROUTES.ACCOUNT_STATUS}`);
    }else{
      history.push(ROUTES.HOME);
    }
    
  }

  const handleClearValues = () => {
    setCc("")
    setAllCc([])
    setSelectedCc("")
  }

  const formik = useFormik({
    initialValues: {
      email: email,
      Supplier_NIF: (availablesCUIT?.length === 1 ? availablesCUIT[0]?.cuit : selectedCuit) || (origin === 'fromAccount' && nifValueFromAccount[0]) || null,
      CC: "",
      Title: "",
      Description: "",
      society: selectedSociety || (origin === 'fromAccount' && societyValueFromAccount[0]) || null,
      CategoryId: selectedCategory || null,
      InvgateCategoryId: selectedSubCategoryId || (origin === 'fromAccount' && subCategoryValueFromAccount[0]) || null,
    },

    onSubmit: (values, { resetForm }) => {

      let error = false;
      setOnSubmit(true)

      let formData = objectToFormData(
        {
          ...values,
          SupplierData_ID: supplierTickets.guid,
          SupplierData_Email: email,
          InvgateCategoryId: selectedSubCategoryId,
          CustomFields: { ...supplierCustomField, ...countryCustomField, ...documentCustomField, ...customFieldValues },
          CC: selectedCc
        });

      /* console.log("---------- Inicio ----------")
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      console.log("---------- Fin ----------") */

      for (let i = 0; i < selectedFiles.length; i++) {
        const element = selectedFiles[i];
        formData.append("attachments", element)
      }

      if (!values.society) {
        enqueueSnackbar(`SOCIEDAD es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        setOnSubmit(false)
        error = true;
      }

      if (!values.Supplier_NIF) {
        enqueueSnackbar(`El NIF es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        setOnSubmit(false)
        error = true;
      }

      if (!selectedSubCategoryId) {
        enqueueSnackbar(`CATEGORÍA y SUB-CATEGORÍA son requeridos`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        setOnSubmit(false)
        error = true;
      }

      if (values.Title === '') {
        enqueueSnackbar(`TITULO es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        setOnSubmit(false)
        error = true;
      }

      if (values.Description === '') {
        enqueueSnackbar(`DESCRIPCIÓN es requerido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        setOnSubmit(false)
        error = true;
      }

      else if (!error) {
        dispatch(newTicket(formData)).then(res => {
          enqueueSnackbar(`Se ha cargado su consulta correctamente`, { variant: "success", action: snackAction, autoHideDuration: 3000 });
          history.push(ROUTES.HOME);
          setOnSubmit(false)
        })
          .catch(err => {
            console.dir(err)
            enqueueSnackbar(err.message, { variant: "error", action: snackAction, autoHideDuration: null });
            resetForm();
            setOnSubmit(false)
          });
      }
    },
  });

  return (

    <Card className={classes.card}>
      <Grid container spacing={2} alignItems="center" display="flex" >

        <Grid item xs={12}>
          <Typography marginBottom={1} fontSize={20}>Nueva Consulta</Typography>
        </Grid>

        <Grid item xs={6}>
          <FormControl
            fullWidth
          >
            <InputLabel>
              Sociedad Techint a Facturar
            </InputLabel>
            <Select
              id="society"
              name="society"
              variant="outlined"
              color="success"
              label="Sociedad Techint a Facturar"
              value={formik.values.society || (origin === 'fromAccount' && societyValueFromAccount[0]) || null}
              onChange={(e) => {
                e.preventDefault()
                setSelectedSociety(e.target.value)
                formik.handleChange(e);
              }}
              error={
                formik.touched.society && Boolean(formik.errors.society)
              }
            >
              {societies.map((soc) => (
                <MenuItem key={soc.id} value={soc.id}>
                  <em>{soc.nif} - {soc.description}</em>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <TextField
            variant="outlined"
            color="success"
            disabled
            fullWidth
            inputProps={{ readOnly: "readonly" }}
            label="Usuario Final"
            value={formik.values.email}
            error={
              formik.touched.email && Boolean(formik.errors.email)
            }
            helperText={formik.touched.email && formik.errors.email}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl
            fullWidth
          >
            {availablesCUIT?.length === 0 ? <TextField
              id="Supplier_NIF"
              name="Supplier_NIF"
              variant="outlined"
              color="success"
              label="NIF / RFC / CUIT Proveedor"
              value={formik.values.Supplier_NIF || (origin === 'fromAccount' && nifValueFromAccount[0]) || null}
              onChange={e => {
                e.preventDefault()
                setSelectedCuit(e.target.value)
                formik.handleChange(e);
              }
              }
            /> : availablesCUIT?.length === 1
              ? <><InputLabel>
                NIF / RFC / CUIT Proveedor
              </InputLabel>
                <Select
                  variant="outlined"
                  color="success"
                  label="NIF / RFC / CUIT Proveedor"
                  id="Supplier_NIF"
                  name="Supplier_NIF"
                  value={formik.values.Supplier_NIF || (origin === 'fromAccount' && nifValueFromAccount[0]) || null}
                  onChange={() => setSelectedCuit(availablesCUIT[0]?.cuit)}
                >
                  {availablesCUIT.map((cuit) => (
                    <MenuItem key={cuit.supplierId} value={cuit.cuit}>
                      <em>{`${cuit.cuit} - ${cuit.supplierDescription}`}</em>
                    </MenuItem>
                  ))}
                </Select>
              </>
              : <><InputLabel>
                NIF / RFC / CUIT Proveedor
              </InputLabel><Select
                variant="outlined"
                color="success"
                label="NIF / RFC / CUIT Proveedor"
                id="Supplier_NIF"
                name="Supplier_NIF"
                value={formik.values.Supplier_NIF || (origin === 'fromAccount' && nifValueFromAccount[0]) || null}
                onChange={(e) => {
                  e.preventDefault()
                  setSelectedCuit(e.target.value)
                  formik.handleChange(e);
                }}
                error={
                  formik.touched.cuit && Boolean(formik.errors.cuit)
                }
              >
                  {availablesCUIT?.map((cuit) => (
                    <MenuItem key={cuit.supplierId} value={cuit.cuit}>
                      <em>{`${cuit.cuit} - ${cuit.supplierDescription}`}</em>
                    </MenuItem>
                  ))}
                </Select></>}
          </FormControl>
        </Grid>

        <Grid item xs={selectedCategory ? 6 : 12}>
          <FormControl
            fullWidth
          >
            <InputLabel>
              Categoría
            </InputLabel>
            <Select
              variant="outlined"
              color="success"
              label="Categoría"
              id="CategoryId"
              name="CategoryId"
              value={formik.values.CategoryId || (origin === 'fromAccount' && categoryValueFromAccount[0]) || 0}
              onChange={(e) => {
                e.preventDefault()
                setSelectedSubCategoryId(null)
                if (selectedSociety === 0 || selectedCuit === null) {
                  enqueueSnackbar(`Sociedad y NIF son requeridos`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
                  setSelectedCategory(null)
                } else {
                  e.preventDefault()
                  setSelectedCategory(e.target.value)
                  formik.handleChange(e);
                }
              }}
              error={
                formik.touched.category && Boolean(formik.errors.category)
              }
            >
              {Array.isArray(categories) &&
                categories
                  .filter((category, index, self) => self.findIndex((c) => c.category === category.category) === index)
                  .map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      <em>{category.category}</em>
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </Grid>

        {(selectedCategory || origin === 'fromAccount') && <Grid item xs={selectedCategory ? 6 : 12}>
          <FormControl
            fullWidth
          >
            <InputLabel>
              Sub-Categoría
            </InputLabel>
            <Select
              variant="outlined"
              color="success"
              label="Sub-Categoría"
              id="InvgateCategoryId"
              name="InvgateCategoryId"
              value={formik.values.InvgateCategoryId || (origin === 'fromAccount' && subCategoryValueFromAccount[0]) || 0}
              onChange={(e) => {
                e.preventDefault()
                setSelectedSubCategoryId(e.target.value)
                formik.handleChange(e);
              }}
              error={
                formik.touched.category && Boolean(formik.errors.category)
              }
            >
              {
                Array.isArray(categories) &&
                categories.filter((category) => category.category === categories.find((cat) => cat.id === selectedCategory)?.category)
                  .map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      <em>{category.title}</em>
                    </MenuItem>
                  ))
              }
            </Select>
          </FormControl>
        </Grid>}

        {selectedCuit && selectedSubCategoryId && customFields && <Grid item xs={12} className={classes.category}>
          {customFields.map((field) => {
            if (field.uid === '1') return (
              <Grid item key={field.uid}>
                <TextField
                  disabled
                  fullWidth
                  id="CustomFields"
                  name="CustomFields"
                  variant="outlined"
                  color="success"
                  InputLabelProps={supplierCustomField[1] && { shrink: true }}
                  label={field.label}
                  value={supplierCustomField[1]}
                  /* onChange={e => e.target.value} */
                  error={
                    formik.touched.custom && Boolean(formik.errors.custom)
                  }
                  helperText={formik.touched.custom && formik.errors.custom}
                />
              </Grid>
            )
            if (field.uid === '2') return (
              <Grid item key={field.uid}>
                <TextField
                  disabled
                  fullWidth
                  id="CustomFields"
                  name="CustomFields"
                  variant="outlined"
                  color="success"
                  InputLabelProps={countryCustomField[2] && { shrink: true }}
                  label={field.label}
                  value={countryCustomField[2] && countriesHashValue[0]?.name}
                  /* onChange={countryCustomField[2] && countriesHashValue[0]?.name} */
                  error={
                    formik.touched.custom && Boolean(formik.errors.custom)
                  }
                  helperText={formik.touched.custom && formik.errors.custom}
                />
              </Grid>
            )
            if (field.uid === '6') return (
              <Grid item key={field.uid}>
                <TextField
                  fullWidth
                  id="CustomFields"
                  name="CustomFields"
                  variant="outlined"
                  color="success"
                  InputLabelProps={documentCustomField[6] && { shrink: true }}
                  label={field.label}
                  value={customFieldValues[field.uid] || (origin === 'fromAccount' && invoiceFromAccount) || null}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    const uid = field.uid;
                    const newCustomFieldValues = {
                      ...customFieldValues,
                      [uid]: newValue
                    };
                    setCustomFieldValues(newCustomFieldValues);
                  }}
                  error={
                    formik.touched.custom && Boolean(formik.errors.custom)
                  }
                  helperText={formik.touched.custom && formik.errors.custom}
                />
              </Grid>
            )
            else return (
              <Grid item key={field.uid}>
                <TextField
                  fullWidth
                  id="CustomFields"
                  name="CustomFields"
                  variant="outlined"
                  color="success"
                  label={field.label}
                  value={customFieldValues[field.uid] || ''}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    const uid = field.uid;
                    const newCustomFieldValues = {
                      ...customFieldValues,
                      [uid]: newValue
                    };
                    setCustomFieldValues(newCustomFieldValues);
                  }}
                  error={
                    formik.touched.custom && Boolean(formik.errors.custom)
                  }
                  helperText={formik.touched.custom && formik.errors.custom}
                />
              </Grid>
            )
          })
          }
        </Grid>}

        <Grid item xs={12} display="flex" >
          <Grid item xs={10.8}>
            <TextField
              fullWidth
              disabled
              id="CC"
              name="CC"
              variant="outlined"
              color="success"
              label="CC"
              InputLabelProps={selectedCc && { shrink: true }}
              value={selectedCc}
              onChange={(e) => {
                setSelectedCc(e.target.value)
              }}
              error={
                formik.touched.CC && Boolean(formik.errors.CC)
              }
              helperText={formik.touched.CC && formik.errors.CC}
            />
          </Grid>
          <Grid container xs={1.2} justify="center" alignItems="center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton color="primary" variant="contained" onClick={handleOpenCc} >
              <AddCircleOutlinedIcon />
            </IconButton>
            <IconButton color="error" variant="contained" onClick={handleClearValues} >
              <CancelIcon />
            </IconButton>
            <CcPopup
              openCc={openCc}
              cc={cc}
              allCc={allCc}
              setOpenCc={setOpenCc}
              setCc={setCc}
              setAllCc={setAllCc}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="Title"
            name="Title"
            variant="outlined"
            color="success"
            label="Título"
            value={formik.values.Title}
            onChange={formik.handleChange}
            error={formik.touched.Title && Boolean(formik.errors.Title)}
            helperText={formik.touched.Title && formik.errors.Title}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="Description"
            name="Description"
            label="Descripción"
            multiline
            rows={6}
            fullWidth
            color="success"
            variant="outlined"
            value={formik.values.Description}
            onChange={formik.handleChange}
            error={formik.touched.Description && Boolean(formik.errors.Description)}
            helperText={formik.touched.Description && formik.errors.Description}
          />
        </Grid>

        <Grid item xs={12}>
          <div>
            <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps({ multiple: true })} />
                    {selectedFiles &&
                      Array.isArray(selectedFiles) &&
                      selectedFiles.length > 0 ? selectedFiles.map((file, index) => (
                        <div key={index}>
                          <Chip
                            className={classes.chip}
                            label={file.name}
                            variant="outlined"
                            onDelete={() => handleDelete(file)}
                          />
                        </div>
                      )) : (
                      <>
                        <BackupIcon />
                        <p>
                          Arrastra los archivos aquí o <u> explora</u>
                        </p>
                      </>
                    )}
                  </div>
                  <aside className="selected-file-wrapper"></aside>
                </section>
              )}
            </Dropzone>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
          >
            <Button color="error" onClick={handleClickCancel} variant="outlined">
              Cancelar
            </Button>
            <ButtonSubmitProgress color="primary" loading={onSubmit} variant="contained" onClick={formik.handleSubmit} /* disabled={!availablesCUIT.length} */>
              Enviar
            </ButtonSubmitProgress>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
